/* global $ ga  */
require('../assets/css/index.less');
(function (doc, win) {
  var docEl = doc.documentElement
  var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
  var recalc = function () {
    var clientWidth = docEl.clientWidth
    if (!clientWidth) return
    if (clientWidth >= 640) {
      docEl.style.fontSize = '100px'
    } else {
      docEl.style.fontSize = 100 * (clientWidth / 640) + 'px'
    }
  }
  if (!doc.addEventListener) return
  win.addEventListener(resizeEvt, recalc, false)
  doc.addEventListener('DOMContentLoaded', recalc, false)
})(document, window)

const query = window.location.search.slice(1).match(/albumId=(\d+)/)
const albumId = query ? query[1] : -1

const api = {
  submitInfo: {
    test: 'http://pre.upload.api.apusapps.com/zone/album/get-detail',
    prod: 'http://comm.apusapps.com/zone/album/get-detail'
  }
}

const env = 'prod'

// 请求相册数据
$.ajax({
  type: 'POST',
  url: api.submitInfo[env],
  data: {
    currentPage: 1,
    pageSize: 3,
    albumId: albumId
  },
  success: function ({data}) {
    console.log(data)
    render(data)
  }
})

$('footer').click(() => {
  ga('send', 'event', 'link', 'click', 'toGooglePlay-global-person-space-share-171207')
  window.location.href = 'https://play.google.com/store/apps/details?id=com.xpro.camera.lite'
})

// 模板渲染
function render (data) {
  const {describe = '', date, list = []} = data || {}
  $('header .title').html(describe)
  $('header .date').html(date ? formatTime(date) : formatTime(parseInt(Date.now() / 1000)))
  list.filter((item) => {
    return item.status === 0
  }).forEach((item) => {
    $('.images').append($('<img />').attr('src', item.url))
  })
}

// 格式化时间
function formatTime (seconds) {
  return new Date(seconds * 1000).toDateString().split(' ').slice(1).join('. ')
}



// WEBPACK FOOTER //
// ./src/pages/global.js